'use strict';

var d3 = require('d3');
var Scales = function Scales(params, dateRange) {
  var x = d3.scale.linear().domain(dateRange).range([0, params.width]);
  var y = d3.scale.ordinal().domain(['inbound', 'outbound']).rangeBands([0, params.height], 0.1, 0.35);
  return {
    xScale: x,
    yScale: y
  };
};
Scales.$inject = ['MomentService'];
module.exports = Scales;